const STRONG_PASSWORD_NO_CASE_SENSITIVE = 1;
const STRONG_PASSWORD_CASE_SENSITIVE = 2;

/**
 * {
 *  isRenewPwd (noLogin, noExpired)
 *  strongPassword,
 *  longMinPwd,
 *  longMaxPwd,
 * }
 *
 * @param {*} options
 * @returns
 */
export function getSecurityAlertContent(options) {
  const requirements = edicom.locale.translate(options.strongPassword > 0 ? 'login.password_requirements_special' : 'login.password_requirements');

  const listLi = [];
  !options.isRenewPwd && listLi.push('login.password_requirements_distinct');
  listLi.push(edicom.locale.translate('usersManagement.pwdMinLengthNumber', { passwordMinLength: options.longMinPwd }));
  listLi.push(edicom.locale.translate('usersManagement.pwdMaxLengthNumber', { passwordMaxLength: options.longMaxPwd }));
  listLi.push('usersManagement.pwdAllowedCharacters');
  options.strongPassword === STRONG_PASSWORD_NO_CASE_SENSITIVE && listLi.push('login.password_requirements_nocasesensitive');
  options.strongPassword === STRONG_PASSWORD_CASE_SENSITIVE && listLi.push('login.password_requirements_casesensitive');

  return `<div style="white-space:normal">
    <small>
      <ewc-icon name="info"></ewc-icon>
      <strong>${requirements}</strong>
      <ul>
        ${listLi.map(getLiItem).join('')}
      </ul>
    </small>
  </div>`;
}

function getLiItem(item) {
  return `<li>${edicom.locale.translate(item)}</li>`;
}
